import { Trans, useTranslation } from "react-i18next"

import buildingIcon from "@assets/buildingIcon.png"
import Button from "@components/Button"
import Layout from "@components/Layout"
import { Form } from "react-router-dom"

export default function BuildingPage() {
  const { t } = useTranslation()

  return (
    <Layout>
      <div className="flex grow flex-col items-center justify-center gap-5 text-center">
        <img
          src={buildingIcon}
          alt="Building icon"
          className="h-auto w-40 rounded-lg"
        />

        <h1 className="custom-heading">
          {t("pages.onboarding.building.heading")}
        </h1>

        <p className="text-lg">
          <Trans
            components={{
              bold: <span className="font-bold" />,
            }}
            i18nKey="pages.onboarding.building.text"
          />
        </p>
      </div>

      <Form className="shrink-0" method="post">
        <input
          name={t("pages.onboarding.building.heading", { lng: "en" })}
          type="hidden"
          value={t("shared.continue", { lng: "en" })}
        />

        <Button title={t("shared.continue")} type="submit" />
      </Form>
    </Layout>
  )
}
